import React, { useRef, useState } from "react";
import { Carousel } from "antd";
import type { CarouselRef } from "antd/es/carousel";
import Card, { CardProps } from "./Card";
// import { title } from "process";

const btnStyle: React.CSSProperties = {
  color: "white",
  backgroundColor: "#D9D9D9",
  transition: "width 0.3s", // Add smooth transition
};

interface ACarouselProps {
  cardData: CardProps[]; // Array of CardProps objects
}

const ACarousel: React.FC<ACarouselProps> = ({ cardData }) => {
  const ref = useRef<CarouselRef>(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const goTo = (slide: number) => {
    if (ref.current) {
      ref.current.goTo(slide, false);
    }
  };

  const onChange = (newSlide: number) => {
    setCurrentSlide(newSlide);
  };

  return (
    <div>
      <Carousel ref={ref} afterChange={onChange} dots={false} infinite autoplay>
        {cardData.map((card, index) => (
          <div key={index}>
            <Card title={card.title} excerpt={card.excerpt} imageSrc={card.imageSrc} imageLeft={card.imageLeft}/>
          </div>
        ))}
      </Carousel>
      <div className="flex justify-center items-center gap-2 pt-8">
        {cardData.map((_, index) => (
          <button
            key={index}
            onClick={() => goTo(index)}
            style={{
              ...btnStyle,
              borderRadius: currentSlide === index ? "18px" : "50%",
              width: currentSlide === index ? "40px" : "15px",
              height: "13px", // Fixed height
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ACarousel;
